import type { LanguageCode } from "@/types/languages";

export interface LanguageDefinition {
  code: LanguageCode;
  /** English-readable language name. */
  label: string;
  /** Native spelling of the language name. */
  nativeLabel: string;
}

export const LANGUAGE_DEFINITIONS: Record<LanguageCode, LanguageDefinition> = {
  "en-US": {
    code: "en-US",
    label: "English",
    nativeLabel: "English",
  },
  "de-DE": {
    code: "de-DE",
    label: "German",
    nativeLabel: "Deutsch",
  },
};

export const SUPPORTED_LANGUAGES = Object.keys(LANGUAGE_DEFINITIONS) as LanguageCode[];

export const DEFAULT_LANGUAGE: LanguageCode = "en-US";
